import React, { useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { setAdminToken } from "../lib/adminAuth";
import { Lock, Loader2, ShieldCheck } from "lucide-react";

export default function AdminAccess() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      setAdminToken(data.token);
      setPassword("");
    } catch (err) {
      setError(err.response?.data?.detail || "Could not sign in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[100dvh] items-center justify-center watercolor-wash px-5" data-testid="admin-access-page">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm rounded-2xl bg-ivory-50 p-8 shadow-xl ring-1 ring-ivory-400/50"
      >
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gold/15 text-gold-deep">
          <Lock strokeWidth={1.5} className="h-5 w-5" />
        </span>
        <h1 className="mt-4 text-center font-display text-2xl text-ink">Casey's Studio</h1>
        <p className="mt-1 text-center text-sm text-ink-muted">Enter the admin passphrase to continue. Your session stays open for 12 hours.</p>
        <input
          type="password"
          value={password}
          onChange={(e) => { setPassword(e.target.value); if (error) setError(""); }}
          placeholder="Passphrase"
          autoFocus
          data-testid="admin-password-input"
          className="mt-5 w-full rounded-lg border border-ivory-400/70 bg-[#FCFBF7] p-3 text-center text-ink focus:outline-none focus:ring-1 focus:ring-gold/50"
        />
        {error && (
          <p className="mt-2 text-center text-sm text-terracotta" data-testid="admin-login-error">{error}</p>
        )}
        <button
          type="submit"
          disabled={loading || !password}
          data-testid="admin-login-submit"
          className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-ink px-6 py-3 font-display text-ivory-50 disabled:opacity-50"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} Enter
        </button>
      </form>
    </div>
  );
}
